import { render } from "./confirmPopup.vue?vue&type=template&id=c402bcdc&scoped=true&ts=true"
import script from "./confirmPopup.vue?vue&type=script&lang=ts"
export * from "./confirmPopup.vue?vue&type=script&lang=ts"

import "./confirmPopup.vue?vue&type=style&index=0&id=c402bcdc&lang=scss&scoped=true"

import exportComponent from "/builds/gh_prod_devops/gh_prod_devops_web/webtrade_prod_deploy/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c402bcdc"]])

export default __exports__